import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const VendorProtectedRoute = () => {
  const token = localStorage.getItem("vendorPhone"); // Adjust if using cookies or another storage

  return token ? <Outlet /> : <Navigate to="/vendorportal" replace />;
};

export default VendorProtectedRoute;
